var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconStopLive = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 2H3.4C2.07452 2 1 3.07452 1 4.4V6.8H2.6V4.4C2.6 3.95817 2.95817 3.6 3.4 3.6H5.8V2Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.6V13.2H2.6V15.6C2.6 16.0418 2.95817 16.4 3.4 16.4H5.8V18H3.4C2.07452 18 1 16.9255 1 15.6Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4 13.2V15.6C15.4 16.0418 15.0418 16.4 14.6 16.4H12.2V18H14.6C15.9255 18 17 16.9255 17 15.6V13.2H15.4Z",
    fill: "#FCFCFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.4V6.8H15.4V4.4C15.4 3.95817 15.0418 3.6 14.6 3.6H12.2V2H14.6C15.9255 2 17 3.07452 17 4.4Z",
    fill: "#FCFCFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.4C10.3255 12.4 11.4 11.3255 11.4 10C11.4 8.67452 10.3255 7.6 9 7.6C7.67452 7.6 6.6 8.67452 6.6 10C6.6 11.3255 7.67452 12.4 9 12.4Z",
    fill: "#FCFCFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18.9412L0.0588467 1.99999L1.11951 0.939331L18.0607 17.8805L17 18.9412Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconStopLive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-stop-live.8bb16d55d23d71e58485ccb09417f878.svg";